<template>
    <div :id="id" class="alert alert-warning">
        <h3 v-if="title" class="text-warning"><exclamation-thick />{{ title }}</h3>
        <p class="text-warning" v-html="text" />
    </div>
</template>

<script>
import ExclamationThick from "vue-material-design-icons/ExclamationThick.vue";

export default {
    components: {
        ExclamationThick,
    },
    props: {
        id: { type: String, default: "" },
        title: { type: String, default: "" },
        text: { type: String, default: "" },
    },
};
</script>

<style>
.alert {
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}

.alert-warning {
    background-color: #fcf8e3;
    border-color: #faf2cc;
    color: #8a6d3b;
}

.text-warning {
    color: #ffbc34 !important;
}
</style>
